module.exports = __webpack_public_path__ + "static/img/platform.251739b3.png";